import JEN_HowSFWork_Animation from '@/assets/animation/JEN_HowSFWork-Animation_Web--v04.json';
import { WaveformIcon } from '@/components/Icons';
import { Button } from '@/components/ui/button';
import { cn } from '@/utils';
import Lottie from 'lottie-react';

export default function MarketHeader({ trackListRef }: { trackListRef: React.RefObject<HTMLDivElement> }) {
  return (
    <div className="container mx-auto px-4">
      <div className="flex flex-col gap-8">
        {/* Title Section */}
        <div className="space-y-6">
          <h1>
            <span className="block text-[1.5rem] text-jen-orange font-normal leading-[1.5rem] tracking-[-5%]">
              StyleFilter™ Marketplace.
            </span>
            <span className="block text-[1.5rem] font-normal leading-[1.5rem] tracking-[-5%]">
              A patented groundbreaking
              <br />
              tool in music creation.
            </span>
          </h1>
          <div className="flex flex-col w-full gap-4">
            <Button
              size="lg"
              variant="default"
              className={cn('w-full', '!bg-jen-orange hover:!bg-jen-orange/80', 'text-white')}
              onClick={() => {
                window.open('https://jenmusic.ai/stylefilters', '_blank');
              }}
            >
              What is a StyleFilter™?
            </Button>
            <Button
              variant="outline"
              size="lg"
              className="w-full border-1 text-[#48484B] border-[#CECFD3] py-3 px-4 tracking-[-3%]"
              onClick={() => {
                if (trackListRef.current) {
                  trackListRef.current.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              <WaveformIcon className="mr-2 h-4 w-4" />
              StyleFilter™ Jenerated Tracks
            </Button>
          </div>
        </div>

        {/* How it Works Section */}
        <div className="w-full">
          <div className="w-full">
            <div className="flex items-center justify-between">
              <h2 className="font-medium">How StyleFilters™ Work</h2>
              <Button
                variant="link"
                className="!text-[#9D9DA6] hover:!text-gray-700 underline"
                onClick={() => {
                  window.open('https://jenmusic.ai/stylefilters', '_blank');
                }}
              >
                Learn More
              </Button>
            </div>
            <Lottie animationData={JEN_HowSFWork_Animation} className="" />
          </div>
        </div>
      </div>
    </div>
  );
}
